<template>
  <div class="hello">
   <!--  <ul id="menu"><li data-menuanchor="page1" class="active"><a href="#page1">Section 1</a></li> <li data-menuanchor="page2"><a href="#page2">Section 2</a></li> <li data-menuanchor="page3"><a href="#page3">Section 3</a></li> </ul>
    <full-page ref="fullpage" :options="options" id="fullpage">

    <div class="section">
      First section ...
    </div>
    <div class="section">
      Second section ...
    </div>
  </full-page> -->
    <!-- <img src="../assets/2019OA.png" width="100%"> -->
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false
    }
  },
  methods: {
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    }
  }
}

</script>
<style type="text/css">
  .hello {

  }
</style>
